import React, { Component } from "react";
import { modal } from "../modal";
import Accordion from "semantic-ui-react/dist/commonjs/modules/Accordion";
import areas from "../areas";
import { Link } from "../../lib/Link";
import masterData from "../../lib/masterData";
import { getUrl } from "../../lib/masterUtil";

export const menu_big_area = props => {
  const { value } = props;
  const getPrefUrl = prefSlug => {
    if (value) {
      const prefId = masterData.pref.bySlug[prefSlug].prefId;
      return getUrl({ condition: Object.assign({ pref: prefId }, value.condition) })
    } else {
      const queryString = location.search ? 'list/' + location.search : '';
      return `/${prefSlug}/${queryString}`
    }
  }
  const rootPanels = areas.map((area, index) => {
    return {
      key: index,
      title: area.title,
      content: {
        key: index,
        content: (
          <ul>
            {area.children.map(pref => (
              <li>
                <Link to={getPrefUrl(pref)}>{masterData.pref.bySlug[pref].shortName}</Link>
              </li>
            ))}
          </ul>
        ),
      },
    };
  });
  return (
    <div className="menu_big_area modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title">トランクルームを検索</div>
      <Accordion panels={rootPanels} styled />
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/menu_big_area.jsx